import React from "react";
import styles from "./GameEnd.css";
import { Text } from "../../atoms/Text/Text";
import { Button } from "../../atoms/Buttons/Base";
import { AARPAnalytics } from "../../services/Analytics/AARPAnalytics";
import { Fa } from "../../atoms/Icons/Fa";
import classNames from "classnames";

type GameEndScoreProps = {
  score: number;
  highScore: number;
  isUserAuthorized: boolean;
  onLoginClick?: () => void;
  onPlayAgainClick?: () => void;
  isGameScoreHacked?: boolean;
};

export class GameEndScore extends React.Component<GameEndScoreProps> {
  formatScore = (score: number) => {
    if (score < 1000000) {
      return score.toLocaleString(); // No formatting for scores less than 1,000,000
    }
  
    const suffixes = ["", "K", "M", "B", "T"];
    const value = Math.floor(Math.log10(score) / 3);
    const formattedValue = (score / Math.pow(1000, value)).toFixed(1);
  
    return `${formattedValue}${suffixes[value]}`;
  };

  render() {
    const {
      score,
      highScore,
      isUserAuthorized,
      isGameScoreHacked,
      onLoginClick,
      onPlayAgainClick,
    } = this.props;
    return (
      <Row>
        <ScoreBox data-element-description="game-end scorebox-scores">
          <Text align="center" bold={true} color="aarp-light-gray" style={{fontFamily: "montserrat"}}>
            Score
          </Text>
          <Text
            align="center"
            bold={true}
            color="aarp-dark-gray"
            className={styles.scoreText}
            style={{fontFamily: "montserrat"}}
          >
            {this.formatScore(score)}
          </Text>
        </ScoreBox>
        <ScoreButtonsContainer>
          {!isUserAuthorized ? (
            <GameEndLoginButton
              data-element-description="game-end login-button"
              aria-label="Game End Button"
              onClick={onLoginClick}
              {...AARPAnalytics.attr1Get()}
              {...AARPAnalytics.attrSaveScoreGameEnd()}
            >
              <Text size="xxl" color="main" style={{fontFamily: "montserrat"}}>
                <Fa icon="lock" />
                Log in {!isGameScoreHacked ? " to save your score!" : null}
              </Text>
            </GameEndLoginButton>
          ) : (
            <HighScore data-element-description="game-end scorebox-highscore">
              <Text align="center" bold={true} color="main" style={{fontFamily: "montserrat"}}>
                Your High Score:
                <Text
                  align="center"
                  style={{ paddingLeft: 5, fontFamily: "montserrat" }}
                  bold={true}
                  color="aarp-light-gray"
                >
                  {this.formatScore(highScore)}
                </Text>
              </Text>
            </HighScore>
          )}
          <PlayAgainButton
            isUserLoggedIn={isUserAuthorized}
            aria-label="Play Again Game Button"
            data-element-description="game-end play-again-button"
            onClick={onPlayAgainClick}
          >
            <Fa icon="sync" />
            <Text margin="0 0 0 5px" style={{fontFamily: "montserrat"}}>Play Again</Text>
          </PlayAgainButton>
        </ScoreButtonsContainer>
      </Row>
    );
  }
}

const ScoreButtonsContainer = (props: any) => (
  <div className={styles.gameEndScoreButtonsContainer} {...props} />
);

const ScoreBox = (props: any) => (
  <div className={styles.gameEndScoreBox} {...props} />
);
const HighScore = (props: any) => (
  <div className={styles.gameEndHighScore} {...props} />
);
const GameEndLoginButton = (props: any) => (
  <Button className={styles.gameEndLoginButton} {...props} />
);

const PlayAgainButton = (
  ({ isUserLoggedIn, ...props }: any) => (
    <Button
      className={classNames(styles.gameEndPlayAgainButton, {
        [styles.PlayAgainLoggedIn]: isUserLoggedIn,
        [styles.PlayAgainAnonymous]: !isUserLoggedIn,
      })}
      {...props}
    />
  )
);

const Row = (props: any) => (
  <div className={styles.gameEndScoreRow} {...props} />
);
